import { useState } from "react";
import pos_ico from "../../common/images/pos-other-1.png";
import pos_ico_2 from "../../common/images/pos-other-2.png";

const WhyChooseUs = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const items = [
    {
      title: "Customizable Solutions",
      messages: "Designed to fit your unique business needs!",
    },
    {
      title: "Secure & Reliable",
      messages: "Encrypted transactions and secure data handling.",
    },
    {
      title: "Cloud-Based & Offline Access",
      messages: "Access your data from anywhere, even without an internet connection.",
    },
    {
      title: "Seamless Integration",
      messages: "Compatible with existing accounting, inventory, and CRM platforms.",
    },
    {
      title: "24/7 Support",
      messages: "Our expert support team is always available to assist you.",
    },
  ];

  return (
    <div className="max-w-[1280px] mx-auto px-5 md:px-10 py-7">
      <div className="text-center mb-10">
        <h2 className="md:text-5xl text-3xl font-bold">
          Why Choose Binary Ops Pvt Ltd?
        </h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
      </div>

      <ul className="space-y-6 max-w-[1000px] mx-auto">
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-center justify-between border-dashed border-b-2 border-yellow-400 py-3 relative group"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="flex items-center gap-2 text-base md:text-lg font-semibold text-[#095C9D]">
              <span className="text-[#095C9D] font-medium text-lg md:text-2xl">
                0{index + 1}.
              </span>
              <span
                className={`font-bold text-lg md:text-xl transition-colors duration-300 ${
                  hoveredIndex === index ? "text-[#FFC300]" : ""
                }`}
              >
                {item.title}
              </span>
            </div>

            <img
              src={hoveredIndex === index ? pos_ico_2 : pos_ico}
              alt="arrow"
              className="size-7 transition-transform duration-300"
            />

            {hoveredIndex === index && (
              <div className="absolute right-16 top-0 z-10 animate-fade-in">
                <div className="bg-[#FFC300] text-black text-sm px-3 py-2 rounded-lg shadow-xl small:w-[200px] space-y-2">
                  <div className="bg-yellow-200 rounded p-2">{item.messages}</div>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WhyChooseUs;
